var $8041861d7d017652$exports = {};
$8041861d7d017652$exports = {
    "info": `Teave`,
    "negative": `Viga`,
    "notice": `Hoiatus`,
    "positive": `Valmis`
};


export {$8041861d7d017652$exports as default};
//# sourceMappingURL=et-EE.mjs.map
